import {React} from 'common'
import TextField from '@mui/material/TextField'

const Input = ({variant = 'standard', ...p}) => (
    <TextField sx={{width: '100%'}} variant={variant} {...p} />
)

export default Input
